export default {
    type: 'news',
    aliases: {
        camel: 'news',
        singular: 'News',
        plural: 'News',
        lowerSingular: 'news',
        lowerPlural: 'news',
    },
    relations: {
        'modules': {
            pivot: {
                type: 'news-modules',
                localKey: 'newsId',
                foreignKey: 'moduleId'
            }
        },
        'people': {
            adminLabel: "People",
            pivot: {
                type: 'person-news',
                localKey: 'newsId',
                foreignKey: 'personId'
            }
        },
    },
    publishable: true,
    adminSection: 'news-and-views',
    componentType: 'base',
    filterOn: {
        'other': ['isPublished'],
    },
    components: {
        adminCollection: {
            name: 'AdministerPublishableCollection',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollection')
        },
        adminCollectionItem: {
            name: 'AdministerPublishableCollectionItem',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollectionItem')
        },
        adminRecord: {
            name: 'AdministerNewsRecord',
            loader: () => import('./AdministerNewsRecord')
        },
        webRecord: {
            name: 'DisplayNewsRecord',
            loader: () => import('./DisplayNewsRecord')
        },
        webCollectionItem: {
            name: 'NewsPoster',
            loader: () => import('./NewsPoster')
        }
    },
};
